import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';
import { useCategoriesListQuery } from '../queries';
import { ForwardedRef, forwardRef } from 'react';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> & {
  query?: Parameters<typeof useCategoriesListQuery>[0];
};

function CategorySelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data, isLoading } = useCategoriesListQuery(props.query);

  return (
    <Input.Select
      options={data?.map(d => [d.label, d.id]) ?? []}
      placeholder={props.placeholder ?? 'Alla kategorier'}
      aria-label={props['aria-label'] ?? 'Kategori'}
      disabled={isLoading || props.disabled}
      ref={ref}
      {...props}
    />
  );
}

export const CategorySelect = forwardRef(CategorySelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof CategorySelectElement>;
